@if (gvs.showInstallNotification()) {
    <div class="header-update-warning text-info text-center">
        Schedule2.IT has been updated with new features. Click 
        &nbsp;
        <button 
            type="button" 
            (click)="hardReload()" 
            class="btn btn-secondary btn-sm"
        >HERE</button> 
        &nbsp;
        to reload the page.
    </div>
}

@if (
    sec.getUser() != null 
    && gvs.showContactNotification()
) {
    <div class="header-update-warning text-info text-center">
        You do not currently have a primary narcotic, billing, and/or medical director contact. Click 
        &nbsp;
        <button 
            type="button" 
            (click)="changeContact()"
            class="btn btn-secondary btn-sm"
        >HERE</button> 
        &nbsp;
        to set one.
    </div>
}

@if (gvs.showScheduledInstallNotification()) {
    <pcg-install-timer class="w-100"></pcg-install-timer>
}